import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosGet from "../axios/axios-get";
import axiosPost from "../axios/axios-post";
import axiosPut from "../axios/axios-put";
import axiosDelete from "../axios/axios-delete";

const BASE_URL = "/financial-report";

export const FinancialReportAPI = Object.freeze({
  getAll: createAsyncThunk(
    "get/financial-report",
    async (params, { rejectWithValue }) => {
      try {
        const response = await axiosGet.get(BASE_URL, {
          params,
          headers: {
            locale: "am",
          },
        });
        return response.data;
      } catch (err) {
        return rejectWithValue(
          err.response?.data?.message ?? err.response?.data ?? err.message
        );
      }
    }
  ),

  getOne: createAsyncThunk(
    "get/one-financial-report",
    async (id, { rejectWithValue }) => {
      try {
        const response = await axiosGet.get(`${BASE_URL}/${id}`);
        return response.data;
      } catch (err) {
        return rejectWithValue(
          err.response?.data?.message ?? err.response?.data ?? err.message
        );
      }
    }
  ),

  create: createAsyncThunk(
    "post/financial-report",
    async (data, { rejectWithValue }) => {
      try {
        const response = await axiosPost.post(BASE_URL, data);
        return response.data;
      } catch (err) {
        return rejectWithValue("Something went wrong");
      }
    }
  ),

  update: createAsyncThunk(
    "update/financial-report",
    async (data, { rejectWithValue }) => {
      try {
        const response = await axiosPut.put(`${BASE_URL}/${data.id}`, data);
        return response.data;
      } catch (err) {
        return rejectWithValue(
          err.response?.data?.message ?? err.response?.data ?? err.message
        );
      }
    }
  ),

  delete: createAsyncThunk(
    "delete/financial-report",
    async (id, { rejectWithValue }) => {
      try {
        const response = await axiosDelete.delete(`${BASE_URL}/${id}`);
        return { id, ...response.data };
      } catch (err) {
        return rejectWithValue(
          err.response?.data?.message ?? err.response?.data ?? err.message
        );
      }
    }
  ),
});
